import React from 'react';
import Language from '@Components/Language';
import { Dropdown } from 'primereact/dropdown';
import { IData } from '@Types/IData';
import { Calendar } from 'primereact/calendar';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { ItemPickList } from '@Pages/Portal/FormGroups/FormGroup';
import {ActionButtonTemplate} from "@Components/DataTable/ActionButtonTemplate";

export const preservationOptions = {
  preserveState: true,
  preserveScroll: true,
};

// Record Status

// Document Policy
export const documentTypes: StatusData[] = [
  {
    value: 'document',
    label: Language.get('Document'),
  },
  {
    value: 'policy',
    label: Language.get('Policy'),
  },
];

// Yes no drop down options
export const yesNoSelections: StatusData[] = [
  {
    value: 'yes',
    label: Language.get('Yes'),
  },
  {
    value: 'no',
    label: Language.get('No'),
  },
];

export const certificateStatusSelections: StatusData[] = [
  {
    value: 'pending',
    label: Language.get('Pending'),
  },
  {
    value: 'approved',
    label: Language.get('Approved'),
  },
  {
    value: 'rejected',
    label: Language.get('Rejected'),
  },

];

export const trueFalseSelections: TrueFalseStatusData[] = [
  {
    value: true,
    label: Language.get('Yes'),
  },
  {
    value: false,
    label: Language.get('No'),
  },
];

// convert string to date object
export const convertToDate = (date: string) => (date ? new Date(date) : undefined);

export const recordStatusOptions: StatusData[] = [
  { label: Language.get('Active'), value: 'active' },
  { label: Language.get('Archived'), value: 'archive' },
  { label: Language.get('Disabled'), value: 'disable' },
];

export const getRecordStatusOptions = (tableType: string): StatusData[] => {
  switch (tableType) {
    case 'tableAccessGroup':
      return [
        { label: Language.get('Active'), value: 'active' },
        { label: Language.get('Archived'), value: 'archive' },
      ];
    // Add more cases as needed for different tables
    default:
      return recordStatusOptions; // Default options
  }
};

export const statusRowFilterTemplate = (options: {
  field: string;
  value: string;
  filterCallback: (arg0: any, arg1: any) => void;
  filterApplyCallback: (value: string) => void;
  index: any;
  tableType?: string;
  showClear?: boolean;
}) => {
  const item = (option: StatusData) => {
    return <span className={`record-status status-${option.value.toLowerCase()}`}>{Language.get(option.label)}</span>;
  };

  const optionsList = [
    { label: Language.get('All'), value: 'all' },
    ...getRecordStatusOptions(options.tableType || 'default'),
  ];

  return (
    <Dropdown
      value={options.value}
      options={optionsList}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      itemTemplate={item}
      placeholder={Language.get('Select Status')}
      className="p-column-filter"
      showClear={options?.showClear ?? true}
      style={{ minWidth: '12rem' }}
    />
  );
};

export const companyIdFilterTemplate = (
  options: {
    value: string;
    filterCallback: (arg0: any, arg1: any) => void;
    filterApplyCallback: (value: string) => void;
    index: any;
  },
  companies: IData[]
) => (
  <Dropdown
    optionLabel="name"
    optionValue="record_id"
    options={companies}
    value={options.value}
    filter
    placeholder={Language.get('Company')}
    onChange={(e) => {
      options.filterApplyCallback(e.value);
    }}
    // itemTemplate={item}
    className="p-column-filter"
    showClear
    style={{ minWidth: '12rem' }}
  />
);

export const dropdownFilterTemplate = (
  options: {
    field: string;
    value: string;
    filterCallback: (arg0: any, arg1: any) => void;
    filterApplyCallback: (value: string) => void;
    index: any;
  },
  props: {
    options: IData[];
    placeholder: string;
    optionValue?: string;
    optionLabel?: string;
  }
) => (
  <Dropdown
    optionLabel={props.optionLabel || 'name'}
    optionValue={props.optionValue || 'remote_id'}
    options={props.options}
    value={options.value}
    filter
    placeholder={props.placeholder}
    onChange={(e) => {
      options.filterCallback(e.value, options.index);
    }}
    className="p-column-filter"
    showClear
    style={{ minWidth: '12rem' }}
  />
);

export const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
  return (
    <Calendar
      value={options.value}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      dateFormat="dd/mm/yy"
      selectionMode="range"
      showButtonBar
      readOnlyInput
      hideOnRangeSelection
      placeholder={Language.get('Date From - To')}
    />
  );
};

export const documentTypeFilterTemplate = (options: {
  value: string;
  filterCallback: (arg0: any, arg1: any) => void;
  filterApplyCallback: (value: string) => void;
  index: any;
}) => (
  <Dropdown
    value={options.value}
    options={documentTypes}
    onChange={(e) => options.filterApplyCallback(e.value)}
    placeholder={Language.get('Select Document Type')}
    className="p-column-filter"
    showClear
    style={{ minWidth: '12rem' }}
  />
);

export const yesNoFilterTemplate = (
  options: {
    field: string;
    value: string;
    filterCallback: (arg0: any, arg1: any) => void;
    filterApplyCallback: (value: string) => void;
    index: any;
  },
  placeholder: string
) => (
  <Dropdown
    value={options.value}
    options={yesNoSelections}
    onChange={(e) => options.filterCallback(e.value, options.index)}
    placeholder={placeholder}
    className="p-column-filter"
    showClear
    style={{ minWidth: '12rem' }}
  />
);

export const certificateStatusFilterTemplate = (
  options: {
    field: string;
    value: string;
    filterCallback: (arg0: any, arg1: any) => void;
    filterApplyCallback: (value: string) => void;
    index: any;
  },
  placeholder: string
) => (
  <Dropdown
    value={options.value}
    options={certificateStatusSelections}
    onChange={(e) => options.filterCallback(e.value, options.index)}
    placeholder={placeholder}
    className="p-column-filter"
    showClear
    style={{ minWidth: '12rem' }}
  />
);

export const editRowButton = (params: IData, routeName: string, type?:  "view" | "edit" | "create" | "upload" | "delete" | undefined, label?: string, button_type?: 'button' | 'submit') => {  console.log(button_type)
  return (
    <div className="flex justify-content-start">
      <ActionButtonTemplate edit_route={route(routeName, params)} type={type} label={label} button_type={button_type} />
    </div>
  );
};
export const actionRowButton = (params: IData, routeName: string, action?: 'view' | 'edit' | undefined, button_type?: 'button' | 'submit') => {
  return (
    <div className="flex justify-content-start">
      <ActionButtonTemplate edit_route={route(routeName, params)} type={action} button_type={button_type} />
    </div>
  );
};


export const formatNumber = (num: number) => {
  if (Number(num) >= 1000) {
    return `${(Number(num) / 1000).toFixed(0)} km`;
  }

  return `${Number(num).toString()} m`;
};

export const itemPickOnlyTemplate = (item: ItemPickList, prop: 'title' | 'label' | 'name' = 'title') => (
  <div className="flex flex-wrap p-2 align-items-center gap-3">
    <div className="flex-1 flex flex-column gap-2">
      <span>{item?.[prop]}</span>
    </div>
  </div>
);

export const handleDownload = (fileUrl: string | undefined) => {
  if (fileUrl) {
    // Create an anchor element and set the download attribute
    const link: any = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.download = fileUrl.split('/').pop();
    link.click();
  }
};


export function hexToRgba(hex: string, alpha = 0.3) {
  // Ensure it's a valid hex format
  if (!/^#[0-9A-F]{6}$/i.test(hex)) return hex;

  // Remove the '#' character
  const hexColor = hex.slice(1);

  // Convert hex to RGB
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);

  // Return the rgba string with the desired alpha
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function isImage(url: string) {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(url);
}

export const getTargetFields = (
  dataTargetSource: { record_id: string, record_status: string }[],
  formAccessObjects: string[] | undefined,
  object_type: string) => {
  if (!dataTargetSource) {
    return { addedData: [], removedData: [] };
  }

  // Find added forms
  const addedForms = dataTargetSource.filter(
    (item: { record_id: string, record_status: string}) => !formAccessObjects?.includes(item.record_id)
  );

  const addedData = addedForms.map((item: { record_id: string, record_status: string }) => ({
    collection_object_id: item.record_id,
    object_type: object_type,
    status: item.record_status, // 'active' or current status
  }));

  // Find removed forms
  const removedForms = formAccessObjects?.filter(
    (recordId: string) =>
      !dataTargetSource.some((item: { record_id: string}) => item.record_id === recordId)
  );

  const removedData = (removedForms ?? []).map((recordId: string) => ({
    collection_object_id: recordId,
    object_type: object_type,
    status: 'deactive', // Mark as deactivated
  }));

  return { addedData, removedData }; // ✅ Now returning correct data!
};

export const tryParseLatLng = (text: string): { lat: number; lng: number } | null => {
  const latlng = text.split(',');
  if (latlng.length !== 2) return null;

  const lat = Number(latlng[0].trim());
  const lng = Number(latlng[1].trim());

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  if (lat === 0 && lng === 0) return null; // reject 0,0

  return { lat, lng };
};


export  const valueStyle = "text-md text-color";
export  const labelStyle = "mb-2 font-bold";

type FieldProps = {
  labelKey?: string;
  label?: any;
  value?: any;
  wrapperClass?: string;
};
export const InfoField = ({ labelKey, value, label, wrapperClass = responsiveField }: FieldProps) => (
  <div className={wrapperClass}>
    <p className={labelStyle}>{labelKey ? Language.get(labelKey) : label}</p>
    <span className={valueStyle}>{value ?? '-'}</span>
  </div>
);
export const leftColumn = 'col-12';
export const rightColumn = 'col-12';

export const responsiveField = "col-12 xl:col-4 xxl:col-3 mb-4"
export const responsiveField4 = "col-12 md:col-4 mb-4"
export const responsiveField6 = "col-12 md:col-6 mb-4"
export const responsiveField8 = "col-12 md:col-8 mb-4"
export const responsiveField12 = "col-12 md:col-12 mb-4"

export const acceptedTypes = '.jpg,.jpeg,.png,.gif,.webp'


